<script setup lang="ts">
defineProps<{
  knowledgeBase: PublicKBKnowledgeBase
  compact?: boolean
}>()
</script>

<template>
  <header
    class="bg-cover! bg-center!"
    :style="{
      background: knowledgeBase?.hero_url ? `url(${knowledgeBase?.hero_url})` : `#${knowledgeBase?.primary_color}`,
      color: knowledgeBase?.header_theme == 'light' ? '#fff' : '#000',
    }"
  >
    <Container class="flex items-center justify-between">
      <InertiaLink v-if="knowledgeBase.logo_url" :href="knowledgeBase.path">
        <img class="h-8 w-auto" alt="Logo" :src="knowledgeBase.logo_url" />
      </InertiaLink>

      <div class="flex items-center gap-2">
        <a
          v-if="knowledgeBase.secondary_button_text && knowledgeBase.secondary_button_url"
          :href="knowledgeBase.secondary_button_url"
          class="p-3 leading-none font-medium"
          :class="{
            'text-white hover:text-gray-200': knowledgeBase.header_theme == 'light',
            'text-gray-800 hover:text-black': knowledgeBase.header_theme == 'dark',
          }"
          target="_blank"
          >{{ knowledgeBase.secondary_button_text }}</a
        >
        <a
          v-if="knowledgeBase.primary_button_text && knowledgeBase.primary_button_url"
          :href="`${knowledgeBase.primary_button_url}`"
          class="rounded-lg p-3 leading-none font-medium hover:brightness-90"
          :style="`background-color: #${knowledgeBase.secondary_color};`"
          :class="{
            'text-white hover:bg-gray-900': knowledgeBase.button_theme == 'light',
            'text-gray-800 hover:bg-gray-100': knowledgeBase.button_theme == 'dark',
          }"
          target="_blank"
          >{{ knowledgeBase.primary_button_text }}</a
        >
      </div>
    </Container>

    <Container :class="[compact ? 'mt-8 sm:mt-8' : 'mt-8 sm:mt-32']">
      <div
        v-if="!compact && knowledgeBase.hero_text"
        class="mb-6 text-3xl font-semibold tracking-wide"
        :class="{
          'text-white': knowledgeBase.header_theme == 'light',
          'text-gray-900': knowledgeBase.header_theme == 'dark',
        }"
      >
        {{ knowledgeBase.hero_text }}
      </div>
      <PublicKBSearch :theme="knowledgeBase.header_theme" />
    </Container>
  </header>
</template>

<i18n lang="yaml">
de:
  sign_up: "Kostenlos testen"
  contact_support: "Support kontaktieren"
</i18n>
